module.exports = __webpack_public_path__ + "static/media/dataVisable.5d3d879a.png";